import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { initObservability } from './observability/sentry.js';

window.__CRM_CONFIG__ = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? '',
};

import '@styles/tokens.css';
import '@styles/base.css';
import '@styles/grid.css';
import '@styles/layout.css';
import '@styles/components.css';
import '@styles/timeline.css';
import '@styles/dashboard.css';
import '@styles/crm-shell.css';
import '@styles/deal-form.css';
import '@styles/quick-create-popup.css';
import '@styles/confirm-dialog.css';
import '@styles/responsive.css';
import '@styles/rbac.css';
import '@styles/dark-theme.css';
import '@styles/full-page-loader.css';
import '@styles/shadcn.css';

initObservability();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
